exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs {\n\tborder-bottom-color: #777;\n}\n\n.nav-tabs > li > a {\n\tborder-color: #777;\n\tbackground-color: #f8f8f8;\n}\n\n.nav-tabs > li.active > a {\n\tborder-bottom-color: transparent;\n\tbackground-color: #66615b;\n\tcolor: white;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/display/display.component.css
// module id = ../../../../../src/app/display/display.component.css
// module chunks = main